export default "__VITE_ASSET__CIqHMOSA__"